import { useCheckAccountTraits } from '@cmg/auth';

export const useCheckWallCrossTrait = () => {
  return useCheckAccountTraits(['XC_WALL_CROSS']);
};
